import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ID } from '@datorama/akita';
import { Parameter, ParameterQuery, Product, ProductQuery, ProductService, StringHelper, UrlHelperService } from '@lobos/library';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { iif, of } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-catalog-redirect',
  template: '',
})
export class CatalogRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private translocoService: TranslocoService,
    private urlHelper: UrlHelperService,
    private productService: ProductService,
    private productQuery: ProductQuery,
    private parameterQuery: ParameterQuery,
  ) {}

  public ngOnInit(): void {
    this.parameterQuery.params$
      .pipe(
        map((params: Parameter) => {
          const url = this.urlHelper.getPath();
          const catalog = StringHelper.trim('/' + this.urlHelper.normalize(params.sCatalogName), '/');
          const urlPath = StringHelper.trim(url.substring(3), '/');
          return `/${catalog}/${urlPath}/`;
        }),
        switchMap((path: string) =>
          iif(
            () => this.productQuery.hasEntity((entity: Product) => entity.sUrlPath === path),
            this.productQuery.selectEntity((entity: Product) => entity.sUrlPath === path),
            this.productService
              .getByUrl(this.urlHelper.getPath())
              .pipe(switchMap((product: Product) => (product ? this.productQuery.selectById(product.Id) : of(undefined)))),
          ),
        ),
        map((product: Product | undefined) => {
          if (!product) {
            return [this.translocoService.getActiveLang(), 'not-found'];
          }

          return [this.translocoService.getActiveLang(), product.sType === 'P' ? 'product' : 'category-filter', product.Id];
        }),
        untilDestroyed(this),
        first(),
      )
      .subscribe(async (commands: ID[]) => {
        await this.router.navigate(commands, {
          skipLocationChange: true,
          queryParams: this.urlHelper.getQueryParams(),
        });
      });
  }
}
